/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  var touchingCarousel = false, touchStartCoords;

  document.body.addEventListener('touchstart', function (e) {
    if (e.target.closest('.flickity-slider')) {
      touchingCarousel = true;
    } else {
      touchingCarousel = false;
      return;
    }

    touchStartCoords = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY
    };
  });

  document.body.addEventListener('touchmove', function (e) {
    if (!(touchingCarousel && e.cancelable)) {
      return;
    }

    var moveVector = {
      x: e.touches[0].pageX - touchStartCoords.x,
      y: e.touches[0].pageY - touchStartCoords.y
    };

    if (Math.abs(moveVector.x) > 7)
      e.preventDefault();

  }, { passive: false });
})();

/*/ Shop The Look
$('body').on('stl.updateCartDetails', function(evt, cart) {
  if (typeof cart.items !== 'undefined') {
    var addedItem = cart.items[cart.items.length - 1];
    var event = new CustomEvent('product:added', {
      bubbles: true,
      detail: {
        variant: addedItem,
        quantity: addedItem.quantity
      }
    });

    document.dispatchEvent(event);
  }


});*/

// ----- Custom JS PDP ----
// document.addEventListener("DOMContentLoaded", () => {
//   let nameColor = document.querySelector('span[data-color]').dataset.color;
//   let nameSize = document.querySelector('span[data-size]').dataset.size;
//      updoption();

//     let mediaQuery = window.matchMedia('(min-width: 1008px)');
//     if (mediaQuery.matches) {
//       document.querySelector(`.selected-option-${nameColor} .arrow-option`).addEventListener("click", () => {
//         updoption(true);
//         document.querySelector(`.selected-option-${nameColor} .arrow-option`).classList.toggle('close');
//         document.querySelector(`.selected-option-${nameSize} .arrow-option`).classList.add('close');
//         document.querySelector(`.option-block-${nameSize}`).classList.add('close');
//         document.querySelector(`.option-block-${nameColor}`).classList.toggle('close');
//       });
//       document.querySelector(`.selected-option-${nameSize} .arrow-option`).addEventListener("click", () => {
//         updoption(true);
//         document.querySelector(`.selected-option-${nameSize} .arrow-option`).classList.toggle('close');
//         document.querySelector(`.selected-option-${nameColor} .arrow-option`).classList.add('close');
//         document.querySelector(`.option-block-${nameColor}`).classList.add('close');
//         document.querySelector(`.option-block-${nameSize}`).classList.toggle('close');
//       });
//     } else {
//       document.querySelector(`.option-block-${nameColor} .ProductForm__Label`).addEventListener("click", () => {
//         updoption(true);
//         document.querySelector(`.selected-option-${nameColor} .arrow-option`).classList.toggle('close');
//         document.querySelector(`.selected-option-${nameSize} .arrow-option`).classList.add('close');
//         document.querySelector(`.option-block-${nameSize}`).classList.add('close');
//         document.querySelector(`.option-block-${nameColor}`).classList.toggle('close');
//       });
//       document.querySelector(`.option-block-${nameSize} .ProductForm__Label`).addEventListener("click", () => {
//         updoption(true);
//         document.querySelector(`.selected-option-${nameSize} .arrow-option`).classList.toggle('close');
//         document.querySelector(`.selected-option-${nameColor} .arrow-option`).classList.add('close');
//         document.querySelector(`.option-block-${nameColor}`).classList.add('close');
//         document.querySelector(`.option-block-${nameSize}`).classList.toggle('close');
//       });
//     }


//     document.querySelector('.ColorSwatchList').addEventListener("click", () => {
//       updoption(true);
//       document.querySelector(`.selected-option-${nameColor} .arrow-option`).classList.toggle('close');
//       document.querySelector(`.selected-option-${nameSize} .arrow-option`).classList.add('close');
//       document.querySelector(`.option-block-${nameSize}`).classList.add('close');
//       document.querySelector(`.option-block-${nameColor}`).classList.toggle('close');
//     });
//     document.querySelector('.SizeSwatchList').addEventListener("click", () => {
//       updoption(true);
//       document.querySelector(`.selected-option-${nameColor} .arrow-option`).classList.add('close');
//       document.querySelector(`.option-block-${nameColor}`).classList.add('close');
//       document.querySelector(`.selected-option-${nameSize} .arrow-option`).classList.toggle('close');
//       document.querySelector(`.option-block-${nameSize}`).classList.toggle('close');
//     });

//   });


 //  function updoption(i){
 //    let nameColor = document.querySelector('span[data-color]').dataset.color;
 //    let nameSize = document.querySelector('span[data-size]').dataset.size;
 //  if(i){
 //    let colorOption = document.querySelector('.ColorSwatchList input:checked').nextElementSibling.cloneNode(true);
 //    document.querySelector(`.selected-option-${nameColor}-p`).replaceChild(colorOption,document.querySelector(`.selected-option-${nameColor}-p`).firstChild);
 //    let sizeOption = document.querySelector('.SizeSwatchList input:checked').nextElementSibling.cloneNode(true);
 //    sizeOption = sizeOption.outerHTML;
 //    document.querySelectorAll(`.selected-option-${nameSize}-p`).forEach((item)=>{
 //      item.innerHTML = sizeOption;
 //    });

 //  }else{
 //    let colorOption = document.querySelector('.ColorSwatchList input:checked').nextElementSibling.cloneNode(true);
 //    document.querySelector(`.selected-option-${nameColor}-p`).prepend(colorOption);
 //    let sizeOption = document.querySelector('.SizeSwatchList input:checked').nextElementSibling.cloneNode(true);
 //    sizeOption = sizeOption.outerHTML;
 //    document.querySelectorAll(`.selected-option-${nameSize}-p`).forEach((item)=>{
 //      item.innerHTML = sizeOption;
 //    });

 //    document.querySelector(`.selected-option-${nameSize} .arrow-option`).classList.add('close');
 //    document.querySelector(`.option-block-${nameSize}`).classList.add('close');
 //  }
 // }

// document.addEventListener("DOMContentLoaded", () => {
//   document.querySelector(`.selected-option-${nameSize} .arrow-option`).classList.add('close');
//   document.querySelector(`.option-block-${nameSize}`).classList.add('close');
// })
// document.addEventListener("DOMContentLoaded", () => {
//   var product_options = document.querySelectorAll('.ProductForm__Variants .ProductForm__Option:not(.no-js)');
//   product_options.forEach(function(item){
//     item.dataset.height = item.clientHeight +'px';
//     item.style.height = item.clientHeight +'px';
//   })
// })

$(function(){
  // $('.ProductForm__Variants .ProductForm__Option:not(.no-js)').each(function(){
  //   $(this).data('height', $(this).height()+'px');

  //    $(this).height($(this).data('height'));
  // })

  $('.ProductForm__Variants .ProductForm__Option:not(.no-js) .top-swatcher').click(function(){
    if($(this).parents('.ProductForm__Option.ProductForm__Option--labelled').hasClass('close')){
      $('.ProductForm__Variants .ProductForm__Option:not(.no-js)').not($(this).parents('.ProductForm__Option.ProductForm__Option--labelled')).addClass('close');
      $('.ProductForm__Variants .ProductForm__Option:not(.no-js)').not($(this).parents('.ProductForm__Option.ProductForm__Option--labelled')).find('.arrow-option').addClass('close');
      $('.ProductForm__Variants .ProductForm__Option:not(.no-js)').not($(this).parents('.ProductForm__Option.ProductForm__Option--labelled')).removeClass('open');
      $('.ProductForm__Variants .ProductForm__Option:not(.no-js)').not($(this).parents('.ProductForm__Option.ProductForm__Option--labelled')).height('38px');
      $(this).find('.arrow-option').removeClass('close');

      $(this).parents('.ProductForm__Option.ProductForm__Option--labelled').removeClass('close');
      $(this).parents('.ProductForm__Option.ProductForm__Option--labelled')[0].style.height = $(this).parents('.ProductForm__Option.ProductForm__Option--labelled')[0].dataset.height;

    }else{
      $(this).find('.arrow-option').addClass('close');

      $(this).parents('.ProductForm__Option.ProductForm__Option--labelled').addClass('close');
      $(this).parents('.ProductForm__Option.ProductForm__Option--labelled').height('38px');
    }

  })

  $('.ProductForm__Variants .ProductForm__Option:not(.no-js)').each(function(){
    $(this).find('.selected-option-p').html($(this).find('.HorizontalList__Item input:checked').parents('.HorizontalList__Item').find('label').clone());
  })

  $('.ProductForm__Variants .ProductForm__Option:not(.no-js)').click(function(){
    $(this).find('.selected-option-p').html($(this).find('.HorizontalList__Item input:checked').parents('.HorizontalList__Item').find('label').clone());
  })

  $('.ProductForm__Variants .ProductForm__Option:not(.no-js) ul.HorizontalList .HorizontalList__Item').click(function(){
    $(this).find('.arrow-option').addClass('close');

    $(this).parents('.ProductForm__Option.ProductForm__Option--labelled').addClass('close');
    $(this).parents('.ProductForm__Option.ProductForm__Option--labelled').height('38px');
  })

})

let inter8 = setInterval(()=>{
  let dots = document.querySelectorAll('ol.flickity-page-dots');
  dots.forEach((dot)=>{
    if(dot.querySelectorAll('.dot').length<2){
      dot.style.display = 'none';
      clearInterval(inter8);
    }
  });

  },800)

calcShoptL();

function calcShoptL(){
  if(document.querySelector(".Product__Aside .Collapsible") !== null){
    var widthL = $(document.querySelector(".Product__Aside .Collapsible")).offset().left;
  widthL = (widthL - 50) + 'px';
  let inter = setInterval(()=>{
    if(document.querySelector('.ctl-cell-wrapper') !== null && screen.width >+ 1008){
      document.querySelector('.ctl-cell-wrapper').style.paddingLeft = widthL;
      clearInterval(inter);
      }
    },100);
    setTimeout(() => {
      clearInterval(inter);
    }, 5000);
  }
}


// -end- Custom JS PDP ----
// handle variant change
document.addEventListener('variant:changed', (e) => {
  const outOfStockText = document.getElementById('not-available-text');
  if(e.detail.variant['available']){
    if(outOfStockText) outOfStockText.classList.add('hidden');
  }else{
    if(outOfStockText) outOfStockText.classList.remove('hidden');
  }
});

// START WISHLIST
let lastValue = localStorage.getItem('swym-products');
const setLabelHeart = () => {
  const wishListHeart = document.querySelector('.swym-launcher-header-icon');

    const localStorageData = localStorage.getItem('swym-products');
  if (localStorageData) {
    const objWishListItems = JSON.parse(localStorageData);
    const amountWishlistItems = objWishListItems.all.length;
    if (amountWishlistItems > 0) {
      let wishHeartAmount = wishListHeart?.querySelector('.whish-heart-Label');
      if (!wishHeartAmount) {
        wishHeartAmount = document.createElement("p");
        wishHeartAmount.classList.add('whish-heart-Label');
        wishListHeart?.appendChild(wishHeartAmount);
      }
      wishHeartAmount.setAttribute('data-amount', amountWishlistItems);
      wishHeartAmount.innerText = amountWishlistItems;
    }
  }
};

const callback = () => {
  const wishListHeart = document.querySelector('.swym-launcher-header-icon');
  const currentValue = localStorage.getItem('swym-products');
  if (currentValue !== lastValue) {
    lastValue = currentValue;
    const parsedData = JSON.parse(currentValue);
    let heartLabel = wishListHeart.querySelector("p");
    const heartLabelAmount = parsedData.all.length;
    if (heartLabel) {
      if (heartLabelAmount > 0) {
        heartLabel.setAttribute('data-amount', heartLabelAmount);
        heartLabel.innerText = heartLabelAmount;
      } else {
        heartLabel.remove();
      }
    } else if (heartLabelAmount > 0) {
      setLabelHeart();
    }
  }
};

const initialObserverForWishList = (mutationsList, observer) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      const targetNodeHeart = document.querySelector('.swym-wishlist-notifications-container');
      const targetNodeWishList = document.querySelector('.swym-modals-container');
      if (targetNodeHeart && targetNodeWishList) {
        setLabelHeart();
        const config = { attributes: true, childList: true, subtree: true };
        const observerHeart = new MutationObserver(callback);
        const observerWishlist = new MutationObserver(callback);

        observerHeart.observe(targetNodeHeart, config);
        observerWishlist.observe(targetNodeWishList, config);
        
        observer.disconnect();
        break;
      }
    }
  }
};

const targetElement = document.querySelector('.wishlist-container');
if (targetElement) {
  console.log('first stage', targetElement)
  const observer = new MutationObserver(initialObserverForWishList);
  observer.observe(targetElement, { childList: true, subtree: true });
} else {
  console.error('The target element with class "hello" was not found.');
}

